import { useEffect } from 'react';

export function useReveal(): void {
  useEffect(() => {
    document.documentElement.classList.add('js');
    if (typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    const els = document.querySelectorAll('.reveal');
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
